interface Props {
  /** Mostra o monograma (logo-ax.svg) antes do texto. Default true. */
  showIcon?: boolean
  /** Classe de tamanho do ícone. Default h-8 w-8. */
  iconClassName?: string
  /** Classe de tamanho do texto. Default text-lg. */
  textClassName?: string
  /** Renderiza sobre fundo escuro (chrome navy): "ax-" fica claro em vez de navy. */
  onDark?: boolean
  className?: string
}

/**
 * Wordmark "ax-kanban" — "ax-" em ink (navy no claro / claro no escuro) + "kanban"
 * em laranja, na fonte Poppins, precedido pelo monograma AX. Fonte única do
 * logotipo no app (header desktop e mobile).
 */
export default function Wordmark({
  showIcon = true,
  iconClassName = 'h-8 w-8',
  textClassName = 'text-lg',
  onDark = false,
  className = '',
}: Props) {
  return (
    <span className={`inline-flex items-center gap-2 min-w-0 ${className}`}>
      {showIcon && (
        <img src="/logo-ax.svg" alt="" className={`${iconClassName} shrink-0`} />
      )}
      <span className={`font-display font-semibold ${onDark ? 'text-white' : 'text-ink'} tracking-tight truncate ${textClassName}`}>
        ax-<span className="text-brand-500">kanban</span>
      </span>
    </span>
  )
}
